/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  IndividualDetailsViewModel,
  NotFoundErrorResult,
  Result,
  ResultOfIndividualDetailsViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    IndividualDetailsViewModelFromJSON,
    IndividualDetailsViewModelToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfIndividualDetailsViewModelFromJSON,
    ResultOfIndividualDetailsViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface IndividualDetailsGetRequest {
    proposalId: number;
}

export interface IndividualDetailsPostRequest {
    proposalId: number;
    personalDetailsViewModel: IndividualDetailsViewModel;
}

/**
 * 
 */
export class IndividualDetailsApi extends runtime.BaseAPI {

    /**
     * Get personal details for an individual.
     */
    async individualDetailsGetRaw(requestParameters: IndividualDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIndividualDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling individualDetailsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/personal-details/individual/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIndividualDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get personal details for an individual.
     */
    async individualDetailsGet(requestParameters: IndividualDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIndividualDetailsViewModel> {
        const response = await this.individualDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the party\'s personal details for an individual.
     */
    async individualDetailsPostRaw(requestParameters: IndividualDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling individualDetailsPost.');
        }

        if (requestParameters.personalDetailsViewModel === null || requestParameters.personalDetailsViewModel === undefined) {
            throw new runtime.RequiredError('personalDetailsViewModel','Required parameter requestParameters.personalDetailsViewModel was null or undefined when calling individualDetailsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/personal-details/individual/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IndividualDetailsViewModelToJSON(requestParameters.personalDetailsViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Posts the party\'s personal details for an individual.
     */
    async individualDetailsPost(requestParameters: IndividualDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.individualDetailsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
